/*
 * Pruebas reales hechas dentro del juego por el staff. Una prueba confirma SOLO lo observado
 * (ese ítem, ese monstruo, ese mapa, esa fecha); nunca convierte el catálogo en "comprobado".
 */

export type InGameTest = {
  /** Identificador de la comprobación propuesta (ver "Copiar todos los pendientes de la guía"). */
  testId: string
  observed: string
  /** AAAA-MM-DD */
  date: string
  tester?: string
  /** Captura o enlace, si existe. */
  evidence?: string
  result: 'coincide' | 'no-coincide'
}

export const inGameTests: InGameTest[] = []

export const inGameTest = (testId: string) => inGameTests.find((t) => t.testId === testId)
